export const de = {
	idStrings: {
		// menu *******************************************************************
		// file **********************************************
		file: "Datei",
		"load-sparql": "Lade aus dem SPARQL Endpunkt",
		"load-session": "Lade gespeicherte Sitzung",
		"load-view": "Lade Teilgraph",
		"load-layout": "Lade Layout von Teilgraph",
		"save-session": "Speichere aktuelle Sitzung",
		"save-snik-graph": "Speichere kompletten Graph als Cytoscape Datei",
		"new-view": "Neuen Teilgraph öffnen",
		"save-view": "Speichere aktuellen Teilgraphen",
		"save-layout": "Speichere Layout des aktuellen Teilgraphen",
		"recalculate-layout-replace": "Layout neu berechnen und im Browser-Cache platzieren",
		"save-image-png-visible-region": "Speichere Bilddatei der aktuellen Ansicht als PNG",
		"save-image-png-complete-partial-graph": "Speichere Bilddatei des kompletten Graphen als PNG",
		"save-image-png-visible-region-high-res": "Speichere Bilddatei der aktuellen Ansicht als PNG (hohe Auflösung)",
		"save-image-png-complete-partial-graph-high-res": "Speichere Bilddatei des kompletten Graphen als PNG (hohe Auflösung)",
		"save-image-svg-visible-region": "Speichere Bilddatei der aktuellen Ansicht als SVG",
		"save-image-svg-complete-partial-graph": "Speichere Bilddatei des kompletten Graphen als SVG",
		// filter ********************************************
		filter: "Filter",
		meta: "meta",
		bb: "BB",
		ob: "OB",
		ciox: "CioX",
		he: "HE",
		it: "IT",
		it4it: "IT4IT",
		bb2: "BB2",
		role: "Rolle",
		function: "Aufgabe",
		entitytype: "Objekttyp",
		"show-classes-with-instances": "Klassen zeigen, die Instanzen haben",
		"show-classes-without-instances": "Klassen zeigen, die keine Instanzen haben",
		subclassof: "subClassOf-Beziehungen",
		"non-subclassof": "nicht-subClassOf-Beziehungen",
		"inter-ontology-relations": "Beziehungen zwischen (Teil-)Ontologien",
		"intra-ontology-relations": "Beziehungen innerhalb von (Teil-)Ontologien",
		// options********************************************
		options: "Optionen",
		separateColours: "Nach Farben trennen",
		cumulativeSearch: "Kumulative Suche",
		grid: "Raster anzeigen",
		dayMode: "Tag-Modus",
		coloredEdges: "Kanten nach Typ einfärben",
		showProperty: "Relationsbeschreibungen immer zeigen",
		devMode: "Entwickler-Modus",
		extMode: "Erweiterter Modus",
		combineMatchMode: "Übereinstimmungen zusammenfassen",
		starNewView: "Stern in neuem Teilgraphen",
		// layout*********************************************
		layout: "Layout",
		"show-close-matches": "Zeige close matches",
		"recalculate-layout": "Layout neu berechnen",
		"tight-layout": "Dichtes Layout",
		//"custom-layout": "Benutzerdefiniertes Layout",
		"compound-layout": "verbundenes Layout",
		"bb-chapter-search": "BB Kapitelsuche",
		"ob-chapter-search": "OB Kapitelsuche",
		"reset-view": "Ansicht des Gesamtgraphen zurücksetzen",
		"move-match-nearby": "Zeige close matches verbunden",
		"move-match-on-top": "Zeige close matches übereinander",
		"subontology-connectivity": "Konnektivität zwischen Subontologien",
		"change-title": "Titel des aktuellen Teilgraphen ändern",
		// services ******************************************
		services: "Services",
		"sparql-endpoint": "SPARQL Endpunkt",
		"rdf-browser": "RDF Browser",
		//"data-quality-evaluation": "Daten-Qualitäts-Erhebung",
		// language ******************************************
		language: "Sprache",
		english: "Englisch",
		german: "Deutsch",
		persian: "Persisch",
		// help **********************************************
		help: "Hilfe",
		manual: "Anleitung (Englisch)",
		tutorial: "Tutorial (Englisch)",
		"layout-help": "Layouthilfe (Englisch)",
		"developer-doc": "Entwicklerdokumentation (Englisch)",
		"youtube-channel": "YouTube-Kanal (Englisch)",
		troubleshooting: "Hilfe zur Fehlerbehebung (Englisch)",
		contribute: "Beitragen (Englisch)",
		"project-homepage": "Projektseite",
		"meta-model": "Metamodell der Ontologie",
		about: "Über SNIK Graph",
		"bug-report": "Fehler melden",
		"feature-request": "Verbesserung für die Visualisierung vorschlagen",
		"feedback-ontology": "Feedback zur Ontologie geben",
		// other *********************************************
		"deselect-all": "alle abwählen",
		"search-field": "Suchfeld",
		"base-mode": "Basismodus",
		"context-menu": "Kontextmenü",
		"incoming-star": "eingehener Stern",
		"outgoing-star": "ausgehender Stern",
		"combine-close-matches": "kombiniere close matches",
		"class-use": "Klassenbenutzung",
		"show-instances": "Instanzen dieser Klasse zeigen",
	},
	messageStrings: {
		"no-search-results-for": "Keine Suchresultate für",
		"ontology-issue-warning":
			"Bitte hier nur Feedback zur Ontologie hinterlassen! Bitte prüfen Sie vorher, ob es schon eine Issue mit diesem Thema gibt. Wenn nicht, bearbeiten wir Ihr Feedback so schnell wie möglich.",
	},
	contextMenuStrings: {
		"edge-edit": "Bearbeiten or melden",
		"edge-hide": "Verstecken",
		"edge-description": "Beschreibung (falls existent)",
		"edge-confirm-link": "Verbindung Bestätigen",
		"edge-dev": "Entwickler",
		"remove-permanently": "Permanent Entfernen",
		debug: "Debug",
		compound: "Compound",
		open: "Öffnen",
		"move-match-on-top": "Gleiche aufeinander bewegen",
		"move-match-nearby": "Gleiche nahe aneinander bewegen",
		"compound-star": "Stern",
		"compound-incoming-star": "Eingehender Stern",
		"compound-outgoing-star": "Ausgehender Stern",
		"compound-path-source": "Pfad als Quelle setzen",
		edit: "Bearbeiten oder melden",
		"class-use": "Klassennutzung",
		hide: "Verstecken",
		description: "Beschreibung (falls existent)",
		"set-path-source": "Pfad als Quelle setzen",
		star: "Stern",
		"incoming-star": "Eingehender Stern",
		"outgoing-star": "Ausgehender Stern",
		path: "Pfad",
		spiderworm: "Spiderworm",
		dev: "Entwickler",
		ext: "Erweitert",
		doublestar: "Doppelter Stern",
		starpath: "Sternenpfad",
		circlestar: "Kreisstern",
		lodlive: "LodLive",
		"move-selected": "Ausgewählte bewegen",
		"close-match": "Nahe matches (close matches)",
		"show-instances": "Instanzen zeigen",
	},
};
